import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_PHASES, canTransitionQuizBuzzer, scoreQuizAnswer, transitionQuizBuzzer } from "./quiz-buzzer-machine.js";
export const GUESS_THE_SONG_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    answerDurationMs: 20_000,
    roundResultDurationMs: 5_000,
    correctBasePoints: 1_000,
    speedBonusMaxPoints: 500
});
const actions = ["START", "ANSWER", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const GUESS_THE_SONG_DEFINITION = defineGame({
    key: "GUESS_THE_SONG",
    metadata: {
        slug: "guess-the-song",
        name: "Guess the Song",
        description: "Ascolta la melodia, scegli il titolo e conquista il bonus velocità.",
        icon: "🎵",
        catalogStatus: "available",
        maturity: "beta",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking", "questions", "audio-output"]
    },
    initialConfig: GUESS_THE_SONG_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "answerDurationMs", "roundResultDurationMs", "correctBasePoints", "speedBonusMaxPoints"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, answerDurationMs: 15_000, roundResultDurationMs: 3_000 }, estimatedMinutes: 5 },
        standard: { configuration: {}, estimatedMinutes: 9 },
        extended: { configuration: { rounds: 15, answerDurationMs: 25_000 }, estimatedMinutes: 14 }
    },
    createInitialState: (config = {}) => ({
        phase: "LOBBY",
        roundNumber: 0,
        totalRounds: config.rounds ?? GUESS_THE_SONG_DEFAULT_CONFIG.rounds,
        pausedFromPhase: null
    }),
    states: QUIZ_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionQuizBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionQuizBuzzer(state.phase, action, state.pausedFromPhase === "QUESTION" || state.pausedFromPhase === "ROUND_RESULT"
            ? { resumePhase: state.pausedFromPhase }
            : {})
    }),
    scoreDelta: (decision) => scoreQuizAnswer(decision === "CORRECT", GUESS_THE_SONG_DEFAULT_CONFIG.answerDurationMs, GUESS_THE_SONG_DEFAULT_CONFIG.answerDurationMs, GUESS_THE_SONG_DEFAULT_CONFIG),
    views: {
        host: "guess-the-song/host",
        player: "guess-the-song/player",
        display: "guess-the-song/display"
    },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:answer"],
        serverToClient: ["action-result", "action-error", "answer-result"]
    }
});
//# sourceMappingURL=guess-the-song-definition.js.map